import React from 'react';
import ReportingSalesDiceSyncPage from '../components/ReportingSalesDiceSyncPage';

const axios = require('axios').default;

const ReportingSalesDiceSyncApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingSalesDiceSyncPage {...props} />;
};

export default ReportingSalesDiceSyncApp;
